import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { STEPS } from './RemoteAccessDialogConstants';
import { Header as StepChoiceHeader, Content as StepChoiceContent } from './Components/StepChoice';
import {
  Header as StepActivationHeader,
  Content as StepActivationContent,
  Footer as StepActivationFooter,
} from './Components/StepActivation';

import './RemoteAccessDialog.scss';

function getStepComponents(props) {
  const { step } = props;

  switch (step) {
    case STEPS.INITIAL: {
      return {
        header: <StepChoiceHeader {...props} />,
        content: <SimpleSpinner className="remote-access-dialog__spinner" />,
        footer: null,
      };
    }
    case STEPS.CHOICE: {
      return {
        header: <StepChoiceHeader {...props} />,
        content: <StepChoiceContent {...props} />,
        footer: null,
      };
    }
    case STEPS.ACTIVATION: {
      return {
        header: <StepActivationHeader {...props} />,
        content: <StepActivationContent {...props} />,
        footer: <StepActivationFooter {...props} />,
      };
    }
    default: {
      Logger.error('RemoteAccessDialog - invalid step');

      return {
        header: null,
        content: null,
        footer: null,
      };
    }
  }
}

function RemoteAccessDialog(props) {
  const { email, fetchDepartments } = props;
  const { header, content, footer } = getStepComponents(props);

  useEffect(() => {
    fetchDepartments(email);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <GeneralDialogLayout
      {...props}
      className="remote-access-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      header={header}
      headerClassName="rx-border-none"
      footer={footer}
      footerClassName="rx-border-none">
      {content}
    </GeneralDialogLayout>
  );
}

RemoteAccessDialog.propTypes = {
  step: PropTypes.string.isRequired,
  email: PropTypes.string,
  fetchDepartments: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default RemoteAccessDialog;
